module.exports = __webpack_public_path__ + "static/media/Untitled-8.d9764753.png";